module.exports = __webpack_public_path__ + "static/media/get-strat-btn.36370398.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/get-strat-btn.webp
// module id = 295
// module chunks = 0